import React, { useState } from 'react';
import { photos, categories } from '../data/photos';
import './Gallery.css';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [imageErrors, setImageErrors] = useState(new Set());

  const filteredPhotos = photos.filter(photo => {
    const matchesCategory = selectedCategory === 'all' || photo.category === selectedCategory;
    const matchesSearch = photo.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         photo.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         photo.vendors.some(vendor => vendor.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const openModal = (photo) => {
    setSelectedPhoto(photo);
  };

  const closeModal = () => {
    setSelectedPhoto(null);
  };

  const handleImageError = (photoId) => {
    setImageErrors(prev => new Set(prev).add(photoId));
  };

  return (
    <div className="gallery">
      <div className="gallery-header">
        <div className="container">
          <h1>Photo Gallery</h1>
          <p>Explore our collection of children's fashion photography</p>
        </div>
      </div>

      <div className="gallery-controls">
        <div className="container">
          <div className="controls-content">
            <div className="search-container">
              <input
                type="text"
                placeholder="Search photos, vendors, or descriptions..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
            
            <div className="category-filters">
              {categories.map(category => (
                <button
                  key={category.id}
                  className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category.id)}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="gallery-content">
        <div className="container">
          {filteredPhotos.length === 0 ? (
            <div className="no-results">
              <h3>No photos found</h3>
              <p>Try adjusting your search terms or category filter.</p>
            </div>
          ) : (
            <div className="photos-grid">
              {filteredPhotos.map((photo) => (
                <div key={photo.id} className="photo-item" onClick={() => openModal(photo)}>
                  {photo.imageUrl && !imageErrors.has(photo.id) ? (
                    <img 
                      src={photo.imageUrl} 
                      alt={photo.title}
                      className="photo-image"
                      onError={() => handleImageError(photo.id)}
                    />
                  ) : (
                    <div className="photo-image-placeholder">
                      <span>{photo.title}</span>
                    </div>
                  )}
                  <div className="photo-overlay">
                    <div className="photo-info">
                      <h3>{photo.title}</h3>
                      <p className="photo-date">{new Date(photo.imageDate).toLocaleDateString()}</p>
                      <p className="photo-vendors">{photo.vendors.join(', ')}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Photo Modal */}
      {selectedPhoto && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
            
            <div className="modal-body">
              {selectedPhoto.imageUrl && !imageErrors.has(selectedPhoto.id) ? (
                <img 
                  src={selectedPhoto.imageUrl} 
                  alt={selectedPhoto.title}
                  className="modal-image"
                  onError={() => handleImageError(selectedPhoto.id)}
                />
              ) : (
                <div className="modal-image-placeholder">
                  <span>{selectedPhoto.title}</span>
                </div>
              )}
              
              <div className="modal-info">
                <h2>{selectedPhoto.title}</h2>
                <div className="modal-meta">
                  <div className="meta-item">
                    <strong>Date:</strong> {new Date(selectedPhoto.imageDate).toLocaleDateString()}
                  </div>
                  <div className="meta-item">
                    <strong>Category:</strong> {categories.find(cat => cat.id === selectedPhoto.category)?.name}
                  </div>
                  <div className="meta-item">
                    <strong>Vendors:</strong>
                    <div className="vendor-tags">
                      {selectedPhoto.vendors.map((vendor, index) => (
                        <span key={index} className="vendor-tag">{vendor}</span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="modal-description">
                  <h3>Description</h3>
                  <p>{selectedPhoto.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
